import React, { useState } from 'react';

import type { FixTableData } from '../types';
import DetailTable from './DetailTable';
import EditFixRecord from './EditFixRecord';
import type { EditFixRecordType } from './types';

const Detail: React.FC<{ fixData: FixTableData; updateFixes: () => void }> = ({
  fixData,
  updateFixes,
}) => {
  const [page, setPage] = useState<'detail' | 'edit'>('detail');
  const [editFixRecord, setEditFixRecord] = useState<EditFixRecordType>(null);

  if (page === 'edit' && editFixRecord) {
    return (
      <EditFixRecord
        fixId={fixData._id}
        editFixRecord={editFixRecord}
        afterEdit={() => {
          setPage('detail');
          setEditFixRecord(null);
          updateFixes();
        }}
        cancelEdit={() => {
          setPage('detail');
          setEditFixRecord(null);
        }}
      />
    );
  }
  return (
    <DetailTable
      fixData={fixData}
      updateFixes={updateFixes}
      startEdit={(editRecord) => {
        setEditFixRecord(editRecord);
        setPage('edit');
      }}
    />
  );
};

export default Detail;
